<template>
    <header class="topbar">
        <b-navbar
            type="light"
            variant="white"
            toggleable="md"
            class="top-navbar"
        >
            <div class="navbar-header">
                <b-navbar-brand :to="{ name: 'admin' }">
                    <logo-horizontal class="logo-full" />
                    <logo-small class="logo-small" />
                </b-navbar-brand>
                <b-navbar-nav class="ml-auto d-md-none">
                    <b-nav-item-dropdown
                        toggle-class="text-muted waves-effect waves-dark pro-pic"
                        right
                    >
                        <template v-slot:button-content>
                            <user-avatar />
                        </template>
                        <b-dropdown-item :to="{ name: 'admin-my-account' }"
                            >My Account</b-dropdown-item
                        >
                        <b-dropdown-item @click.prevent="onClickLogout"
                            >Logout</b-dropdown-item
                        >
                    </b-nav-item-dropdown>
                </b-navbar-nav>
                <b-link
                    class="nav-toggler waves-effect waves-light d-block d-md-none"
                    @click.prevent="toggleSidebar"
                >
                    <b-icon-justify />
                </b-link>
            </div>
            <b-collapse
                id="navbarSupportedContent"
                class="justify-content-between"
                is-nav
            >
                <b-navbar-nav v-if="search_form.available" class="me-auto">
                    <b-nav-item
                        @click.prevent="showSearchForm"
                        class="search-box"
                        link-classes="nav-link waves-effect waves-dark"
                    >
                        <b-icon-search />
                        <span class="font-16"
                            >Search {{ this.search ? `: ${search}` : "" }}</span
                        >
                    </b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav class="ml-auto">
                    <b-nav-item-dropdown
                        toggle-class="text-muted waves-effect waves-dark pro-pic"
                        right
                    >
                        <template v-slot:button-content>
                            <user-avatar />
                        </template>
                        <b-dropdown-item :to="{ name: 'admin-my-account' }"
                            >My Account</b-dropdown-item
                        >
                        <b-dropdown-item @click.prevent="onClickLogout"
                            >Logout</b-dropdown-item
                        >
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
        <form
            class="app-search position-absolute"
            @submit.prevent="submitSearch"
            v-if="search_form.available"
            v-show="search_form.visible"
        >
            <input
                ref="searchInput"
                type="text"
                class="form-control"
                placeholder="Search &amp; enter"
            />
            <b-link @click.prevent="hideSearchForm" class="srh-btn">
                <b-icon-x />
            </b-link>
        </form>
    </header>
</template>

<script>
import UserAvatar from "./UserAvatar";
import { mapActions } from "vuex";
import { API_ROUTES } from "../api";

export default {
    components: { UserAvatar },
    data() {
        return {
            search_form: {
                available: this.$route.meta.has_search,
                visible: false,
            },
        };
    },
    methods: {
        ...mapActions({
            logout: "auth/logout",
        }),
        showSearchForm() {
            this.search_form.visible = true;
            setTimeout(() => {
                this.$refs.searchInput.focus();
            }, 200);
        },
        hideSearchForm() {
            this.search_form.visible = false;
        },
        toggleSidebar() {
            document
                .getElementById("main-wrapper")
                .classList.toggle("show-sidebar");
        },
        onClickLogout() {
            this.$api
                .get(API_ROUTES.LOGOUT_AUTH0)
                .then(() => {
                    this.logout();
                    this.$router.push({ name: "login" });
                })
                .catch(({ response: { data } }) => {
                    let message = data.message ?? "Failed to process logout";
                    this.$bvToast.toast(message, {
                        title: "ERROR",
                        variant: "danger",
                    });
                });
        },
        submitSearch() {
            this.search = this.$refs.searchInput.value;
            this.hideSearchForm();
        },
    },
    computed: {
        search: {
            get() {
                return this.$store.state.current.search;
            },
            set(text) {
                this.$store.commit("current/setSearch", text);
            },
        },
    },
    watch: {
        $route: function (newRoute) {
            this.search_form.available = newRoute.meta.has_search;
            if (this.$refs.searchInput) {
                this.$refs.searchInput.value = "";
            }
            this.hideSearchForm();
        },
    },
};
</script>
